import axios from 'axios';

const api = axios.create({
  baseURL: 'https://main.victriedemos.com:3009',
});

export default api;
